import underscored from 'underscore.string/underscored';

angular.module('gym.contacts').factory('PaymentDetailsSharingService', ["$modal", "$rootScope", "$q", function($modal, $rootScope, $q) {
  var gym;
  gym = $rootScope.gym;
  return {
    share: function(contact) {
      var modalInstance;
      return modalInstance = $modal.open({
        template: require('templates/gyms/contacts/payment_details/share_payment_details.html.slim'),
        controller: 'SharePaymentDetailsCtrl',
        resolve: {
          contact: function() {
            return contact;
          },
          relationships: ["$http", function($http) {
            var url;
            url = `/gyms/${gym.id}/${contact.type}s/${contact.id}/contact_relationships/with_payment_methods`;
            return $http.get(url).then(function(response) {
              return response.data;
            });
          }]
        }
      });
    },
    getSharingOption: function(contact, paymentMethods, provider) {
      var deferred, modalInstance;
      deferred = $q.defer();
      if (paymentMethods[0].all_contacts.length < 2) {
        deferred.resolve({
          updateThisContactOnly: false
        });
      } else {
        modalInstance = $modal.open({
          template: require('templates/gyms/contacts/payment_details/get_sharing_option.html.slim'),
          resolve: {
            contact: function() {
              return contact;
            },
            paymentMethods: function() {
              return paymentMethods;
            },
            provider: function() {
              return provider;
            }
          },
          controller: ["$scope", "$modalInstance", "contact", "paymentMethods", "provider", function($scope, $modalInstance, contact, paymentMethods, provider) {
            var paymentMethod;
            $scope.contact = contact;
            paymentMethod = paymentMethods[0];
            $scope.isStripe = provider === 'stripe';
            $scope.sharedContactName = function(contact) {
              if (contact.name) {
                return contact.name;
              } else {
                return `${contact.first_name} ${contact.last_name}`;
              }
            };
            $scope.contactType = function(contact) {
              return contact.contact_type || contact.type;
            };
            $scope.sharedContacts = _.reject(paymentMethod.all_contacts, function(item) {
              return item.id === contact.id;
            });
            $scope.contactsType = function(contact) {
              var type;
              type = contact.contact_type || contact.type;
              return `${underscored(type)}s`;
            };
            $scope.cancel = function() {
              return $modalInstance.dismiss('cancel');
            };
            $scope.updateForThisContact = function() {
              return $modalInstance.close({
                updateThisContactOnly: true
              });
            };
            return $scope.updateForAllContacts = function() {
              return $modalInstance.close({
                updateThisContactOnly: false
              });
            };
          }]
        });
        modalInstance.result.then(function(sharingOption) {
          return deferred.resolve(sharingOption);
        });
      }
      return deferred.promise;
    }
  };
}]);
